import { PythonTopic } from '../../../../types/python-topic';
import { disenoEspecificacionExercises } from './exercises';

export const disenoEspecificacionTopic: PythonTopic = {
  id: 6,
  title: 'Diseño, especificación, documentación y estilo',
  description: 'Aprende buenas prácticas de diseño de programas, especificación, documentación y estilo de código.',
  theory: `# Diseño, Especificación, Documentación y Estilo

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Diseño de programas**: Cómo estructurar programas de forma efectiva
2. **Especificación**: Documentar qué hace tu código
3. **Documentación**: Escribir documentación clara y útil
4. **Estilo de código**: Seguir convenciones y buenas prácticas

## Diseño de Programas

Aprenderás principios de:
- Diseño modular
- Separación de responsabilidades
- Arquitectura de software

## Documentación y Estilo

Entenderás:
- Cómo documentar código efectivamente
- Convenciones de estilo (PEP 8)
- Buenas prácticas de Python

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'advanced',
  exercises: disenoEspecificacionExercises
};

